import { Pin } from "./Pin";
import { User } from "./User";

export class PinGroup {
    id: number;
    pins: Pin[];
    user: User;
    creationDate: Date;
}